import api from './api';

// Returns true for admin/sports/sporsuperadmin/99, false for regionalsports (personel)
export const isAdminUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const role = (user.userType || user.role || 'admin').toString().toLowerCase();
    return role === 'admin' || role === 'sports' || role === 'sporsuperadmin' || role === '99';
  } catch {
    return true;
  }
};


export const login = async (email, password) => {
  try {
    const invalidCredentialsResponse = {
      isSuccess: false,
      resultMessage: 'E-posta/kullanıcı adı veya şifre hatalı.'
    };

    let response = await api.post('/api/Authentication/Login', {
      email,
      password
    });

    if (!response.isSuccess) {
      // Fallback: Check if the user is a Regional Sports User
      try {
        const regionalResponse = await api.post('/api/sports/regional-users/login', {
          username: email,
          password: password
        });

        if (regionalResponse.isSuccess) {
          localStorage.setItem('token', regionalResponse.token);
          localStorage.setItem('user', JSON.stringify({
            id: regionalResponse.user.id,
            nameSurname: regionalResponse.user.firstName + ' ' + regionalResponse.user.lastName,
            email: regionalResponse.user.email,
            phoneNumber: '',
            isVerified: true,
            userType: regionalResponse.user.userType,
            assignedRegions: regionalResponse.user.assignedRegions
          }));
          localStorage.setItem('isAuthenticated', 'true');
          return regionalResponse;
        } else {
          return {
            ...regionalResponse,
            resultMessage: regionalResponse?.message || regionalResponse?.resultMessage || invalidCredentialsResponse.resultMessage
          };
        }
      } catch (regionalError) {
        const statusCode = regionalError?.response?.status;
        if (statusCode && statusCode >= 500) {
          throw regionalError;
        }

        return invalidCredentialsResponse;
      }
    }

    if (response.isSuccess) {
      localStorage.setItem('token', response.data.jwToken);
      localStorage.setItem('user', JSON.stringify({
        id: response.data.id,
        nameSurname: response.data.nameSurname,
        email: response.data.email,
        phoneNumber: response.data.phoneNumber,
        isVerified: response.data.isVerified,
        userType: response.data.userType || response.data.role,
        role: response.data.role || response.data.userType,
        libraryId: response.data.libraryId || null
      }));
      localStorage.setItem('isAuthenticated', 'true');
    }

    return response;
  } catch (error) {
    if (error?.response?.status === 400 || error?.response?.status === 401) {
      return {
        isSuccess: false,
        resultMessage: 'E-posta/kullanıcı adı veya şifre hatalı.'
      };
    }

    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('isAuthenticated');
  window.location.href = '/login';
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const getLibraryId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.libraryId || null;
  } catch {
    return null;
  }
};

export const isLibraryOnlyUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const role = (user.userType || '').toLowerCase().trim();
    const result = role === 'library' && !!user.libraryId;
    console.log('[DEBUG] isLibraryOnlyUser check:', { role, libraryId: user.libraryId, result });
    return result;
  } catch {
    return false;
  }
};

export const requestAdminPasswordReset = async (email) => {
  try {
    const response = await api.post('/api/Authentication/RequestPasswordReset', { email });
    return response;
  } catch (error) {
    throw error;
  }
};

export const resetAdminPassword = async (email, code, newPassword) => {
  try {
    const response = await api.post('/api/Authentication/ResetPassword', {
      email,
      code,
      newPassword
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyAdminPasswordResetCode = async (email, code) => {
  try {
    const response = await api.post('/api/Authentication/VerifyPasswordResetCode', {
      email,
      code
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const closeAllSessions = async () => {
  try {
    const response = await api.post('/api/Authentication/LogoutAllSessions');
    return response;
  } catch (error) {
    throw error;
  }
};
